import { AdminRouter, AdminSidebar } from 'stylemix-vue-admin'
import { messageGroups } from '../plugins/i18n'

const base = 'affiliates'

AdminRouter.addRoute({
  name: `payouts`,
  path: `/payouts`,
  component: () => import('./Payouts.vue'),
  meta: {
    auth: true,
  },
})
AdminRouter.addRoute({
  name: `deferred_payments`,
  path: `/deferred-payments/`,
  component: () => import('./DeferredPayments.vue'),
  meta: {
    auth: true,
  },
})

AdminSidebar.pushItem({
  id: `${base}.payouts`,
  order: 30,
  header: $vm => $vm.$t(`general.menu_main`),
  text: $vm => $vm.$t(`account.payouts`),
  route: {
    name: `payouts`,
  },
  icon: 'icon-tree5',
  permission({ $account }) {
    return (
      $account && $account.affiliate && $account.deferred_payments === false
    )
  },
})

AdminSidebar.pushItem({
  id: `${base}.deferred_payments`,
  order: 30,
  header: $vm => $vm.$t(`general.menu_main`),
  text: $vm => $vm.$t(`account.payouts`),
  route: {
    name: `deferred_payments`,
  },
  icon: 'icon-tree5',
  permission({ $account }) {
    return $account && $account.affiliate && $account.deferred_payments === true
  },
})

messageGroups.push(base)
messageGroups.push('deferred_payments')
